import getCurrency from "./getCurrency";
export default function updateArrangementsPrice() {
  const arrayArrangements = document.querySelectorAll(".tocalculate .select-field-combo-input__main-field");
  let arrangementsPrice = 0;

  arrayArrangements.forEach((element) => {
    arrangementsPrice += parseFloat(element.innerHTML.split(getCurrency())[0].split("· ")[1]?.replace(",", "."));
  });

  return Number.parseFloat(arrangementsPrice);
}
